module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO03AdministracionDelDinero.fa1450a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO03AdministracionDelDinero.mp4
// module id = 731
// module chunks = 1